<template>
  <div @click="setCollapse">
    <svg-icon
      :icon="isCollapse ? 'hamburger-closed' : 'hamburger-opened'"
      class="hamburger">
    </svg-icon>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Hamburger',

  computed: {
    ...mapGetters(['isCollapse'])
  },

  methods: {
    // 获取vuex中设置菜单是否折叠的方法
    setCollapse () {
      this.$store.dispatch('app/toggleSideBar')
    }
  }
}
</script>

<style lang="scss" scoped>
.hamburger {
  display: inline-block;
  vertical-align: middle;
  width: 18px;
  height: 18px;
}
</style>
